import { Box, Typography, useTheme } from "@mui/material";

interface Props {
  message?: string;
}

export function InputErrorMessage(props: Props) {
  const theme = useTheme();

  return (
    <Box ml={1} mt={"-4px"} height={"14px"}>
      <Typography variant="caption" color={theme.palette.error.main}>
        {props?.message}
      </Typography>
    </Box>
  );
}
